import { Pipe, PipeTransform } from '@angular/core';
import { CommunityGiftCardConfig } from '@greco/gift-cards';

@Pipe({ name: 'giftCardConfigTitle' })
export class GetGiftCardConfigTitlePipe implements PipeTransform {
  transform(config: CommunityGiftCardConfig): string {
    return config.title || 'Gift Card for ' + config.community?.name;
  }
}
